import React from "react";

import { Container, Stack } from "@mui/material";

const MeetingReportsContainer = ({
  children,
}: {
  children?: React.ReactElement;
}) => {
  return (
    <Stack sx={{ width: "100%", height: "100%", pb: 4, bgcolor: "white" }}>
      <Container
        sx={{ flexGrow: 1 }}
        data-test-id="meeting-reports-container"
        maxWidth="xl"
      >
        {children}
      </Container>
    </Stack>
  );
};

export default MeetingReportsContainer;
